module.exports = __webpack_public_path__ + "static/media/Going-Green-Logo.64a5e2dc.svg";